import React from "react";
import { FaArrowRight } from "react-icons/fa";
import { LogoMarquee } from "../../_components/LogoMarquee";
import { ProjectOutsource } from "../../_components/services-tabs";
import { FooterV2 } from "../../_components/FooterV2";
import businessHeroImage from "../../assets/businesses-hero-bg.jpeg";
import section3Card1 from "../../assets/section3-card1.png";
import section3Card2 from "../../assets/section3-card2.png";
import section3Card3 from "../../assets/section3-card3.png";
import { logEvent } from "helpers/analytics";
import flashIconCircle from "../../assets/flash-icon-circle.png";
import moneyIconCircle from "../../assets/money-icon-circle.png";
import smileyFaceIconCircle from "../../assets/smiley-face-icon-circle.png";
import postJobs from "../../assets/post-jobs.png";
import promoteEverywhere from "../../assets/promote-everywhere.png";
import filterSmarter from "../../assets/filter-smarter.png";
import verifyIdentity from "../../assets/verify-identity.png";
import trackPerformance from "../../assets/track-performance.png";
import { Helmet } from "react-helmet";
import { HireOptionsModal } from "../../_components/Modals/HireOptionsModal";
import { RecruitmentConsultationModal } from "../../features/recruitment-consultation";
// import { DemoModal } from "../../_components/Modals";

import cowrywiseLogo from "../../assets/cowrywise-logo.png";
import hugoIncLogo from "../../assets/hugo-inc-logo.jpg";
import promaPaintLogo from "../../assets/proma-paint-logo.png";
import spleetLogo from "../../assets/spleet-logo.png";
import lagoonSchoolLogo from "../../assets/lagoon-school-logo.png";
import arcsAndGlassLogo from "../../assets/arcs-and-glass-logo.jpg";
import crescoHomesLogo from "../../assets/cresco-homes-logo.jpg";
import emelGroupLogo from "../../assets/emel-group-logo.jpeg";
import gemonaWestLogo from "../../assets/gemona-west-logo.webp";
import ledgerisLogo from "../../assets/ledgeris-logo-2.webp";
import meritAfrikaLogo from "../../assets/merit-afrika-logo.jpeg";
import medplusLogo from "../../assets/medplus-logo.webp";
import { PageSection } from "../../_components/PageSection";
import Marquee from "react-fast-marquee";
import { AnimatedCounter } from "../../_components/AnimatedCounter";
import EditIcon from "../../assets/business/icons/edit.svg";
import FindUserIcon from "../../assets/business/icons/find-user.svg";
import ConfidenceIcon from "../../assets/business/icons/confidence.svg";
import { ProjectOutsourcingModal } from "../../features/project-outsourcing";
import ClientsFAQs from "_components/clients-landing-pages/ClientsFAQs";
import { businessFAQs } from "../faqs/constants";
import { useHistory } from "react-router";

const stats = [
  {
    title: "70% faster job completion turnaround",
    icon: flashIconCircle,
  },
  {
    title: "50% lower cost per hire compared to market average",
    icon: moneyIconCircle,
  },

  {
    title: "90%+ customer satisfaction from verified artisans",
    icon: smileyFaceIconCircle,
  },
];

// Mock logo data - replace with actual logo URLs when available
const companyLogos = [
  {
    name: "Cowrywise",
    logo: cowrywiseLogo,
  },
  {
    name: "Hugo",
    logo: hugoIncLogo,
  },
  {
    name: "Proma Paint",
    logo: promaPaintLogo,
  },
  {
    name: "Spleet",
    logo: spleetLogo,
  },
  {
    name: "Lagoon School",
    logo: lagoonSchoolLogo,
  },
  {
    name: "Arcs and Glass",
    logo: arcsAndGlassLogo,
  },
  {
    name: "Cresco Homes",
    logo: crescoHomesLogo,
  },
  {
    name: "Emel Group",
    logo: emelGroupLogo,
  },
  {
    name: "Gemona West",
    logo: gemonaWestLogo,
  },
  {
    name: "Ledgeris",
    logo: ledgerisLogo,
  },
  {
    name: "Merit Africa",
    logo: meritAfrikaLogo,
  },
  {
    name: "Medplus",
    logo: medplusLogo,
  },
];

/**
 * v2 landing page for businesses
 * @returns
 */
const Businesses: React.FC = () => {
  const [isHireOptionsOpen, setHireOptionsOpen] = React.useState(false);
  const [isRecruitmentConsultationOpen, setRecruitmentConsultationOpen] =
    React.useState(false);
  const [isProjectOutsourcingOpen, setProjectOutsourcingOpen] =
    React.useState(false);
  const [projectServiceType, setProjectServiceType] =
    React.useState<"construction" | "facility-maintenance" | "renovations">(
      "construction"
    );

  const navigate = useHistory().push;

  // scroll to sections
  React.useEffect(() => {
    const projectOutsourcingSection = document.getElementById(
      "project-outsourcing"
    );
    const laborhackRecruitCtaSection =
      document.getElementById("laborhack-recruit");
    const recruitmentOutsourcingSection = document.getElementById(
      "recruitment-outsourcing"
    );
    // if url has #project-outsourcing, scroll to it
    if (
      projectOutsourcingSection &&
      window.location.hash === "#project-outsourcing"
    ) {
      projectOutsourcingSection.scrollIntoView({ behavior: "smooth" });
    }
    // if url has #laborhack-recruit, scroll to it
    if (
      laborhackRecruitCtaSection &&
      window.location.hash === "#laborhack-recruit"
    ) {
      laborhackRecruitCtaSection.scrollIntoView({ behavior: "smooth" });
    }
    // if url has #recruitment-outsourcing, scroll to it
    if (
      recruitmentOutsourcingSection &&
      window.location.hash === "#recruitment-outsourcing"
    ) {
      recruitmentOutsourcingSection.scrollIntoView({ behavior: "smooth" });
    }
  }, [window.location.hash]);

  const handleCtaClick = () => {
    logEvent("businesses_page_cta_click", {
      type: "hero_popup",
    });
    setHireOptionsOpen(true);
  };

  const handleRecruitCtaClick = () => {
    logEvent("businesses_page_cta_click", {
      type: "recruit_tool",
    });

    window.open(`${process.env.REACT_APP_MARKETPLACE_URL}`, "_blank");
  };

  const handleConsultingCtaClick = () => {
    logEvent("businesses_page_cta_click", {
      type: "recruitment_consultation",
    });

    setRecruitmentConsultationOpen(true);
  };

  const handleStartProjectFromService = (
    service: "construction" | "facility-maintenance" | "renovations"
  ) => {
    logEvent("businesses_page_cta_click", {
      type: "project_outsourcing",
    });
    setProjectServiceType(service);
    setProjectOutsourcingOpen(true);
  };

  // const WatchDemoButton = () => {
  //   return (
  //     <button
  //       onClick={handleWatchDemo}
  //       className="border border-[#040A0D] text-[#040A0D] px-10 py-[18px] hover:bg-gray-50 transition-colors duration-200 flex items-center gap-2 font-[Inter] text-lg font-medium leading-[1.333]"
  //     >
  //       Watch demo
  //       <FaArrowRight className="w-2 lg:w-3 h-2 lg:h-3" />
  //     </button>
  //   );
  // };

  return (
    <>
      <HireOptionsModal
        isOpen={isHireOptionsOpen}
        onClose={() => setHireOptionsOpen(false)}
      />
      <RecruitmentConsultationModal
        isOpen={isRecruitmentConsultationOpen}
        onClose={() => setRecruitmentConsultationOpen(false)}
      />
      <ProjectOutsourcingModal
        isOpen={isProjectOutsourcingOpen}
        onClose={() => setProjectOutsourcingOpen(false)}
        userType="business"
        serviceType={projectServiceType}
      />
      {/*
      <DemoModal
        isOpen={isDemoModalOpen}
        onClose={() => setDemoModalOpen(false)}
        videoUrl="https://drive.google.com/file/d/1W97_Uk7qv9xjyrAx9m0M2OfKrphAfBlE/view"
        title="LaborHack Recruit demo"
      />
      */}
      <Helmet>
        <title>
          LaborHack Businesses - Hire the right people, the first time.
        </title>
        <meta
          name="description"
          content="From posting to placement, we connect you with verified workers who get the job done right."
        />
      </Helmet>
      {/* Hero Section */}
      <div className="relative w-full h-[500px] md:h-[632px] bg-[#F7F4F4]">
        {/* Background Image (mirrored right to left) with Overlay */}
        <div
          className="absolute top-0 left-0 w-full h-full bg-cover bg-center scale-x-[-1]"
          style={{
            backgroundImage: `url(${businessHeroImage})`,
          }}
        />

        {/* Dark overlay on the left side */}
        <div
          className="absolute top-0 left-0 w-full md:w-[50vw] h-full"
          style={{ backgroundColor: "rgba(18, 18, 18, 0.3)" }}
        />

        {/* Additional overlay for text readability */}
        <div
          className="absolute top-0 left-0 w-full h-full"
          style={{ backgroundColor: "rgba(49, 28, 28, 0.4)" }}
        />

        {/* Content */}
        <PageSection className="h-full relative z-10">
          <div className="h-full flex items-center">
            <div className="max-w-full md:max-w-[600px]">
              <div className="flex flex-col gap-4 md:gap-8">
                {/* Title and Description */}
                <div className="flex flex-col gap-3 md:gap-4">
                  <h1 className="text-[#F0F0F0] text-[36px] md:text-[56px] font-medium leading-tight md:leading-[1.1428571428571428] tracking-tight">
                    Hire the right people,
                    <br className="hidden md:block" /> the first time.
                  </h1>

                  <p className="text-[#FEFEFE] text-base md:text-xl font-normal leading-7 max-w-full md:max-w-[500px]">
                    From posting to placement, we connect you with verified
                    workers who get the job done right.
                  </p>
                </div>

                {/* CTA Button */}
                <div className="flex flex-col sm:flex-row gap-4 items-stretch sm:items-center">
                  {/* Hire Talent Button */}
                  <button
                    onClick={handleCtaClick}
                    className="lg:w-[55%] bg-[#ED6E5C] text-[#FEFEFE] font-inter font-medium text-base md:text-lg px-6 md:px-10 py-3 md:py-5 h-12 md:h-16 flex items-center justify-center gap-2 hover:bg-[#E55D4B] hover:-translate-y-0.5 hover:shadow-lg active:translate-y-0 transition-all duration-200 ease-in-out"
                  >
                    Hire talent
                    <FaArrowRight size="14" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </PageSection>
      </div>

      {/* Logo Marquee Section */}
      <LogoMarquee logos={companyLogos} />

      {/* Third Section - Professional Access */}
      <PageSection className="w-full bg-[#FEFEFE] py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 md:gap-12">
          {/* Access Professionals */}
          <div className="flex flex-col">
            <div className="bg-[#EDEDED] h-fit mb-5 ">
              <img
                src={section3Card1}
                alt="Access 4,000+ pre-vetted professionals."
              />
            </div>
            <h3 className="lg:w-[60%] text-base lg:text-xl font-normal text-gray-900">
              Access 4,000+ pre-vetted professionals.
            </h3>
          </div>

          {/* Save Time with Reviews */}
          <div className="flex flex-col">
            <div className="bg-[#EDEDED] h-fit mb-5 ">
              <img src={section3Card2} alt="Save time and cut rework" />
            </div>
            <h3 className="lg:w-[60%] text-base lg:text-xl font-normal text-gray-900">
              Save time and cut rework with reliable, skilled hands
            </h3>
          </div>

          {/* Scale Operations */}
          <div className="flex flex-col">
            <div className="bg-[#EDEDED] h-fit mb-5 ">
              <img src={section3Card3} alt="Scale operations" />
            </div>
            <h3 className="lg:w-[60%] text-base lg:text-xl font-normal text-gray-900">
              Scale operations without supervision headaches
            </h3>
          </div>
        </div>
      </PageSection>
      <div
        id="laborhack-recruit"
        className="w-full flex flex-col justify-center bg-[#FEFEFE] py-12 md:py-16"
        style={{
          borderTop: "0.5px solid #121212",
          borderBottom: "0.5px solid #121212",
        }}
      >
        {/* Fourth Section - Source. Screen. Hire. */}
        <div className="w-full max-w-screen-2xl mx-auto">
          {/* Section Header */}
          <div className="mb-8 lg:mb-0 px-4 md:px-16 text-center border-b-[0.5px] border-[#121212] pb-6 lg:pb-10">
            <h2 className="text-xl md:text-4xl font-medium text-gray-900 mb-4 font-[AeonikPro]">
              Source. Screen. Hire. All in one place.
            </h2>
            <p className="text-base md:text-xl text-gray-600 font-[Inter]">
              Skip the hassle. Get pre-vetted workers for every job.
            </p>
          </div>

          <div className="relative">
            <div className="border-b-[0.5px] border-[#121212]">
              {/* Top Row - 2 Column Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2">
                {/* Post Step */}
                <div className="px-4 md:pl-0 md:pr-8 flex flex-col items-center justify-center pt-12 md:pt-16 md:pb-0 lg:border-r-[0.5px] lg:border-[#121212]">
                  <div className="w-[70%] lg:w-[40%] flex flex-col gap-4 items-center h-full justify-between">
                    <div className="text-center mb-6">
                      <h3 className="text-xl md:text-[32px] font-normal text-[#212121] mb-3 leading-[1.25] font-[AeonikPro]">
                        Post jobs with precision
                      </h3>
                      <p className="text-base md:text-xl text-[#464646] mb-6 leading-[1.6] max-w-[424px] font-[Inter]">
                        Reach thousands of qualified workers across 10+ trades
                      </p>
                    </div>
                    {/* <WatchDemoButton /> */}
                    <div className="w-full mt-6">
                      <img
                        src={postJobs}
                        alt="Post jobs"
                        className="w-full h-auto border border-[#121212]"
                      />
                    </div>
                  </div>
                </div>

                {/* Promote Step */}
                <div className="px-4 md:pl-8 md:pr-0 flex flex-col items-center justify-center py-12 md:pt-16 md:pb-0">
                  <div className="w-[70%] lg:w-[40%] flex flex-col gap-4 items-center h-full justify-between">
                    <div className="text-center mb-6">
                      <h3 className="text-xl md:text-[32px] font-normal text-[#212121] mb-3 leading-[1.25] font-[AeonikPro]">
                        Promote everywhere
                      </h3>
                      <p className="text-base md:text-xl text-[#464646] mb-6 leading-[1.6] max-w-[424px] font-[Inter]">
                        Auto-post to job boards and reach passive talent
                        nationwide
                      </p>
                    </div>
                    {/* <WatchDemoButton /> */}
                    <div className="w-full mt-6">
                      <img
                        src={promoteEverywhere}
                        alt="Promote everywhere"
                        className="w-full h-auto border border-[#121212]"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="border-b-[0.5px] border-[#121212]">
              {/* Bottom Row - 3 Column Grid */}
              <div className="px-4 md:px-16 grid grid-cols-1 md:grid-cols-3">
                {/* Filter Step */}
                <div className="flex flex-col items-center justify-center py-12 md:pt-16 md:pb-0 px-6 md:pr-10 md:pl-0 lg:border-r-[0.5px] border-[#121212]">
                  <div className="w-[75%] md:w-[65%] flex flex-col gap-4 items-center h-full justify-between">
                    <div className="text-center mb-6">
                      <h3 className="text-xl md:text-[32px] font-normal text-[#212121] mb-3 leading-[1.25] font-[AeonikPro]">
                        Filter smarter
                      </h3>
                      <p className="text-base md:text-xl text-[#464646] mb-6 leading-[1.6] font-[Inter]">
                        Use intelligent screening tools to instantly identify
                        and shortlist the right fit.
                      </p>
                    </div>
                    {/* <WatchDemoButton /> */}
                    <div className="w-full mt-6">
                      <img
                        src={filterSmarter}
                        alt="Filter smarter"
                        className="w-full h-auto border border-[#121212]"
                      />
                    </div>
                  </div>
                </div>

                {/* Verify Step */}
                <div className="flex flex-col items-center justify-center py-12 md:pt-16 md:pb-0 px-6 md:px-8 lg:border-r-[0.5px] border-[#121212]">
                  <div className="w-[75%] md:w-[65%] flex flex-col gap-4 items-center h-full justify-between">
                    <div className="text-center mb-6">
                      <h3 className="text-xl md:text-[32px] font-normal text-[#212121] mb-3 leading-[1.25] font-[AeonikPro]">
                        Verify identity
                      </h3>
                      <p className="text-base md:text-xl text-[#464646] mb-6 leading-[1.6] font-[Inter]">
                        {`Conduct background checks and verify candidates'
                        information and portfolio.`}
                      </p>
                    </div>
                    {/* <WatchDemoButton /> */}
                    <div className="w-full mt-6">
                      <img
                        src={verifyIdentity}
                        alt="Verify identity"
                        className="w-full h-auto border border-[#121212]"
                      />
                    </div>
                  </div>
                </div>

                {/* Track Step */}
                <div className="flex flex-col items-center justify-center py-12 md:pt-16 md:pb-0 px-6 md:pl-10 md:pr-0">
                  <div className="w-[75%] md:w-[65%] flex flex-col gap-4 items-center h-full justify-between">
                    <div className="text-center mb-6">
                      <h3 className="text-xl md:text-[32px] font-normal text-[#212121] mb-3 leading-[1.25] font-[AeonikPro]">
                        Track performance
                      </h3>
                      <p className="text-base md:text-xl text-[#464646] mb-6 leading-[1.6] font-[Inter]">
                        Analyse hiring trends, fill rates, and spend with ease.
                      </p>
                    </div>
                    {/* <WatchDemoButton /> */}
                    <div className="w-full mt-6">
                      <img
                        src={trackPerformance}
                        alt="Track performance"
                        className="w-full h-auto border border-[#121212]"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            {/* LaborHack Recruit Beta Notice */}
            <div className="px-4 md:px-16 py-6 text-center">
              <p className="text-base md:text-lg text-gray-700 font-[Inter]">
                LaborHack Recruit is free to use and in Beta at this moment.
              </p>
            </div>

            <div className="px-4 md:px-16 py-4 flex flex-col sm:flex-row gap-4 items-center justify-center border-b-[0.5px] border-[#121212]">
              {/*
              <button
                onClick={handleWatchDemo}
                className="w-full lg:w-auto bg-transparent text-[#153243] font-inter font-medium text-base md:text-lg px-6 md:px-10 py-3 md:py-5 h-12 md:h-16 flex items-center justify-center gap-2 border border-[#153243] hover:bg-[rgba(21,50,67,0.06)] hover:-translate-y-0.5 active:translate-y-0 transition-all duration-200 ease-in-out"
              >
                Watch demo
              </button>
              */}
              <button
                onClick={handleRecruitCtaClick}
                className="w-full lg:w-auto bg-[#ED6E5C] text-[#FEFEFE] font-inter font-medium text-base md:text-lg px-6 md:px-10 py-3 md:py-5 h-12 md:h-16 flex items-center justify-center gap-2 hover:bg-[#E55D4B] hover:-translate-y-0.5 hover:shadow-lg active:translate-y-0 transition-all duration-200 ease-in-out"
              >
                Use LaborHack Recruit
                <FaArrowRight size="14" />
              </button>
            </div>
          </div>
        </div>

        {/* Fifth Section - Project Outsource */}
        <PageSection>
          <div id="project-outsourcing">
            <ProjectOutsource
              onCtaClick={handleStartProjectFromService}
              userType="business"
            />
          </div>
        </PageSection>
      </div>

      {/* Sixth Section - Get expert recruitment support */}
      <PageSection className="border-b border-prussianBlue-300 py-10 lg:py-16">
        {/* Section Header */}
        <div className="mb-8 md:mb-12" id="recruitment-outsourcing">
          <h2 className="text-2xl md:text-[40px] font-medium text-[#040A0D] leading-[1.2] mb-4 font-[AeonikPro]">
            Get expert recruitment support
          </h2>
          <p className="text-base md:text-xl text-[#464646] leading-[1.6] max-w-[900px] font-[Inter]">
            Get hands-on support from our recruitment experts. From role scoping
            to shortlisting and interview coordination, we help you source and
            hire the best candidates.
          </p>
        </div>

        <div className="border-t-[0.5px] border-[#121212] pt-8 md:pt-12">
          {/* Three Steps */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12 mb-8 md:mb-12">
            {/* Step 1 */}
            <div className="flex flex-col gap-3 md:gap-4 lg:w-[70%] items-start">
              {/* Icon */}
              <div className="w-full flex justify-start">
                <img
                  src={EditIcon}
                  alt="Tell us your needs"
                  className="h-16 lg:h-20"
                />
              </div>
              {/* Text */}
              <div className="flex flex-col gap-2">
                <h3 className="text-lg md:text-[22px] font-medium text-[#212121] leading-[1.318] font-[Inter]">
                  Tell us your needs
                </h3>
                <p className="text-sm md:text-base text-[#464646] leading-[1.875] max-w-[416px] font-[Inter]">
                  Fill out the form so we understand your hiring goals
                </p>
              </div>
            </div>

            {/* Step 2 */}
            <div className="flex flex-col gap-3 md:gap-4 lg:w-[70%] items-start">
              <div className="w-full flex justify-start">
                <img
                  src={FindUserIcon}
                  alt="Find the right fit"
                  className="h-16 lg:h-20"
                />
              </div>
              <div className="flex flex-col gap-2">
                <h3 className="text-lg md:text-[22px] font-medium text-[#212121] leading-[1.318] font-[Inter]">
                  We source & shortlist
                </h3>
                <p className="text-sm md:text-base text-[#464646] leading-[1.875] max-w-[416px] font-[Inter]">
                  Our experts find and pre‑screen the best candidates for you.
                </p>
              </div>
            </div>

            {/* Step 3 */}
            <div className="flex flex-col gap-3 md:gap-4 lg:w-[70%] items-start">
              <div className="w-full flex justify-start">
                <img
                  src={ConfidenceIcon}
                  alt="Hire with confidence"
                  className="h-16 lg:h-20"
                />
              </div>
              <div className="flex flex-col gap-2">
                <h3 className="text-lg md:text-[22px] font-medium text-[#212121] leading-[1.318] font-[Inter]">
                  Hire with confidence
                </h3>
                <p className="text-sm md:text-base text-[#464646] leading-[1.875] max-w-[416px] font-[Inter]">
                  We help you choose and onboard your ideal hire.
                </p>
              </div>
            </div>
          </div>

          <div className="border-t-[0.5px] border-[#121212] pt-8 md:pt-12">
            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 items-stretch sm:items-center">
              {/* Submit Request Button */}
              <button
                onClick={handleConsultingCtaClick}
                className="bg-[#ED6E5C] text-[#FEFEFE] font-inter font-medium text-base md:text-lg px-6 md:px-10 py-3 md:py-5 h-12 md:h-16 flex items-center justify-center gap-2 hover:bg-[#E55D4B] hover:-translate-y-0.5 hover:shadow-lg active:translate-y-0 transition-all duration-200 ease-in-out"
              >
                Submit request
                <FaArrowRight size="14" />
              </button>

              {/* Talk to Specialist Button */}
              <button
                onClick={() => {
                  logEvent("businesses_page_talk_to_specialist_click");
                  window.open(
                    `https://wa.me/2349131598380?text=Hello%20LaborHack`,
                    "_blank"
                  );
                }}
                className="bg-transparent text-[#153243] font-inter font-medium text-base md:text-lg px-6 md:px-8 py-3 md:py-5 h-12 md:h-16 border border-[#153243] hover:bg-[rgba(21,50,67,0.1)] hover:-translate-y-0.5 active:translate-y-0 transition-all duration-200 ease-in-out"
              >
                Talk to a recruitment specialist
              </button>
            </div>
          </div>
        </div>
      </PageSection>

      <PageSection className="bg-white">
        <div className="w-full my-16">
          <div className="border-y border-prussianBlue-300 grid grid-cols-1 md:grid-cols-3 py-16 gap-8">
            <div className="col-span-1 px-5 md:px-0">
              <h2 className="text-2xl md:text-4xl font-medium text-gray-900 mb-4 text-center md:text-left">
                Delivering measurable impact <br className="hidden md:block" />
                for businesses
              </h2>
            </div>
            <div className="col-span-2 relative overflow-hidden hidden md:block">
              <Marquee autoFill={true} speed={150}>
                {stats.map((story, index) => (
                  <div
                    key={`${story.title}-${index}`}
                    className="flex items-center gap-4 min-w-[360px]  md:min-w-[480px] flex-shrink-0"
                  >
                    <img
                      src={story.icon}
                      alt={story.title}
                      className="w-14 h-14"
                    />
                    <p className="text-lg md:text-2xl text-[#212121] font-[Inter] leading-[1.2916667] max-w-96">
                      {story.title}
                    </p>
                  </div>
                ))}
              </Marquee>
            </div>

            <div className="col-span-1 md:hidden px-5">
              <div className="flex flex-col gap-4">
                {stats.map((story, index) => (
                  <div
                    key={`${story.title}-${index}`}
                    className="flex items-center gap-4"
                  >
                    <img
                      src={story.icon}
                      alt={story.title}
                      className="w-14 h-14"
                    />
                    <p className="text-lg md:text-2xl text-[#212121] font-[Inter] leading-[1.2916667] max-w-96">
                      {story.title}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </PageSection>

      {/* <PageSection className="bg-white">
        <div className="flex items-center justify-center py-8 md:py-16">
          <h2 className="text-2xl md:text-4xl font-medium text-prussianBlue-300 text-center md:text-left">
            We&apos;ve helped
            <span className="inline-block mx-2">
              <AnimatedCounter
                target={100}
                suffix="+ companies"
                className="text-2xl md:text-4xl font-semibold font-aeonik text-prussianBlue-500"
              />
            </span>
            get work done
          </h2>
        </div>
      </PageSection> */}

      <ClientsFAQs
        items={businessFAQs}
        onReadAllFAQs={() => navigate("/faqs?tab=businesses")}
      />

      {/* Footer */}
      <FooterV2
        ctaTitle="Vetted, trusted, skilled workers to get work done."
        primaryCtaLabel="Hire talent"
        onPrimaryCta={handleCtaClick}
        // secondaryCtaLabel="Watch demo"
        // onSecondaryCta={handleWatchDemo}
      />
    </>
  );
};

export default Businesses;
